var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0554 8.91512C11.5386 8.40172 11.5386 7.60088 11.0554 7.08748L6.15212 1.87773C5.89978 1.60961 5.47786 1.59683 5.20974 1.84917C4.94163 2.10152 4.92884 2.52343 5.18119 2.79155L10.0845 8.0013L5.18119 13.2111C4.92884 13.4792 4.94163 13.9011 5.20974 14.1534C5.47786 14.4058 5.89978 14.393 6.15212 14.1249L11.0554 8.91512Z",
    fill: "#181B01",
    stroke: "#181B01",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow-right-icon.16349fccfe89b019504046b1176b6136.svg";
export { ForwardRef as ReactComponent };